import './button.css';

import { Icon } from '../icon/icon';

export function ButtonCollection(props) {
    const align = props.align === "right" ? "align-right" : "";
    const noMargins = props.noMargins ? "no-margins" : "";
    const className = props.class ? props.class : "";

    return (
        <div className={`button-collection ${align} ${noMargins} ${className}`}>
            {props.children}
        </div>
    );
}

function getButtonWidth(props) {
    if (props.width === "full") {
        return "width-full";
    }
    
    return "";
}

function getButtonSize(props) {
    if (props.size === "large") {
        return "size-large";
    }

    if (props.size === "small") {
        return "size-small";
    }
    
    return "";
}

function getButtonVariant(props) {
    if (props.variant === "secondary") {
        return "variant-secondary";
    }

    if (props.variant === "alert") {
        return "variant-alert";
    }

    if (props.variant === "label") {
        return "variant-label";
    }

    if (props.variant === "icon") {
        return "variant-icon";
    }

    if (props.variant === "link") {
        return "variant-link";
    }
    
    return "";
}

export function ButtonCollectionSpacer() {
    return <div className="button-collection-spacer"></div>;
}

export function Button(props) {
    const width = getButtonWidth(props);
    const size = getButtonSize(props);
    const variant = getButtonVariant(props);

    const disabled = props.disabled || props.readonly || props.loading;
    const className = props.class || "";

    function click() {
        if (props.clicked) {
            props.clicked();
        }
    };
    
    return (
        <button className={`button ${width} ${size} ${variant} ${className}`}
                onClick={() => click()}
                disabled={disabled}>
            { props.icon && !props.loading &&
                <Icon name={props.icon} class="button-icon" />
            }
            { props.loading &&
                <Icon name="loading" class="button-icon loading-icon" />
            }
            { props.children &&
                props.children
            }
        </button>  
    );
}